module.exports = __webpack_public_path__ + "static/media/8.All types of AC motors.d1974d64.jpg";